import { Folder, Habit } from '../../types';
import { isHabitDateCompleted, isHabitDateTracked, isHabitPeriodCompleted, isPeriodHabit } from '../../utils/habitUtils';
import { PlannerHabitInfo, PlannerTaskInfo } from './types';
import { getLocalDateKey } from './dateUtils';
import { getTaskStartDate } from './scheduleUtils';

export const getTasksWithDueDates = (folders: Folder[], includeCompleted = false): PlannerTaskInfo[] => {
    const tasks: PlannerTaskInfo[] = [];

    folders.forEach((folder) => {
        (folder.collections || []).forEach((collection) => {
            const visitTask = (task: PlannerTaskInfo['task'], parentTitles: string[] = []) => {
                if (getTaskStartDate(task) && (includeCompleted || !task.completed)) {
                    tasks.push({
                        task,
                        folderId: folder.id,
                        collectionId: collection.id,
                        parentTitles,
                    });
                }
                (task.subtasks || []).forEach((subtask) => visitTask(subtask, [...parentTitles, task.title]));
            };
            (collection.elements || []).forEach((element) => {
                if (element.type === 'task') visitTask(element);
            });
        });
    });

    return tasks;
};

export const getUnscheduledTasks = (folders: Folder[]): PlannerTaskInfo[] => {
    const tasks: PlannerTaskInfo[] = [];

    folders.forEach((folder) => {
        (folder.collections || []).forEach((collection) => {
            const visitTask = (task: PlannerTaskInfo['task']) => {
                if (!getTaskStartDate(task) && !task.completed) {
                    tasks.push({
                        task,
                        folderId: folder.id,
                        collectionId: collection.id,
                    });
                }
                (task.subtasks || []).forEach(visitTask);
            };
            (collection.elements || []).forEach((element) => {
                if (element.type === 'task') visitTask(element);
            });
        });
    });

    return tasks;
};

export const getHabitsForDate = (folders: Folder[], date: Date): PlannerHabitInfo[] => {
    const dateStr = getLocalDateKey(date);
    const habits: PlannerHabitInfo[] = [];

    folders.forEach((folder) => {
        (folder.collections || []).forEach((collection) => {
            (collection.elements || []).forEach((element) => {
                const habit = element as Habit;
                const shouldShowPeriodHabit = !isPeriodHabit(habit)
                    || !isHabitPeriodCompleted(habit, dateStr)
                    || isHabitDateCompleted(habit, dateStr);
                if (element.type === 'habit' && isHabitDateTracked(habit, dateStr) && shouldShowPeriodHabit) {
                    habits.push({
                        habit,
                        folderId: folder.id,
                        collectionId: collection.id,
                    });
                }
            });
        });
    });

    return habits;
};
